// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HoverIntent from '@liveauctioneers/react-hoverintent';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import noop from '../../../utils/noop';
import styles from './MegaNavLink.module.scss';

type Props = {
    active: boolean,
    closeNav: Function,
    link: string,
    mobile: string,
    msgId: string,
    openNav: Function,
    tabletNavigation: Function,
};

const MegaNavLink = (props: Props) => {
    const { active, link, mobile, msgId, openNav, closeNav, tabletNavigation } = props;

    const isPhone = mobile && mobile !== 'tablet';
    const isTablet = mobile === 'tablet';
    return (
        <HoverIntent
            onMouseOver={isTablet ? noop : openNav}
            onMouseOut={noop}
            sensitivity={5}
            interval={50}
            timeout={50}
        >
            <div className={`${styles.navLink} ${active && !isPhone ? styles.active : ''}`}>
                <Link onClick={!isTablet ? closeNav : tabletNavigation} route to={isTablet ? '' : link} primaryWeak>
                    <FormattedMessage id={msgId} />
                </Link>
            </div>
        </HoverIntent>
    );
};

export default React.memo<Props>(MegaNavLink, isEqual);
